import { AppBar, Box, capitalize, Chip, Tab, Tabs, TextField } from '@mui/material';
import MButton from 'components/Mbutton';
import useDataFetching from 'hooks/useDataFetching';
import useDebounce from 'hooks/useDebounce';
import { useParams } from 'react-router-dom';
import { config } from 'variables/config';
import MuiTable from 'components/MuiTable';
import { useEffect, useState } from 'react';
import { BsBank2, BsCardHeading, BsPeople } from 'react-icons/bs';

import { ENTERPRISE_REQUEST_HEADER } from 'Constaints';
import { formatDate } from 'utils';
import { EMLOYEE_REQUEST_HEADER } from 'Constaints';
import { formatNumber } from 'utils';
import { CONTRACT_REQUEST_HEADER } from 'Constaints';
import RequestDetails from './RequestDetails';
import { castToRequestParams } from 'utils';
import MuiSelect from 'components/MuiSelect';
import PaginateBox from 'components/PaginateBox';
import { useTranslation } from 'react-i18next';
import { REQUEST_TYPE } from 'Constaints';
import SearchRequestModal from './SearchRequestModal';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Requests = () => {
  const { t } = useTranslation('requests');

  const [params, setParams] = useState({
    page: 0,
    limit: 50,
    status: 'PENDING',
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const [loadingEnter, , enterprises, getEnterprises] = useDataFetching(
    `${config.app.api_url}/user-requests?${castToRequestParams(params)}&requestEntityType=ENTERPRISE`
  );
  const [loadingEM, , employees, getEmployee] = useDataFetching(
    `${config.app.api_url}/user-requests?${castToRequestParams(params)}&requestEntityType=EMPLOYEE`
  );
  const [loadingCOn, , contracts, getContracts] = useDataFetching(
    `${config.app.api_url}/user-requests?${castToRequestParams(params)}&requestEntityType=CONTRACT`
  );

  const getAll = () => {
    getEnterprises();
    getEmployee();
    getContracts();
  }; // Ajout de ;

  const [open, setopen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedTypeUrl, setSetSelectedTypeUrl] = useState('');

  // Search functionality
  const [loadingSearch, , searchData, fetchSearchData] = useDataFetching(
    debouncedSearchTerm?.length > 0
      ? `${config.app.api_url}/user-requests?requestIds=${debouncedSearchTerm}&requestEntityType=EMPLOYEE`
      : null
  );

  // Auto-fetch when debouncedSearchTerm changes
  useEffect(() => {
    if (debouncedSearchTerm?.length > 0) {
      fetchSearchData();
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchTerm]);

  const searchFunction = (term) => {
    setSearchTerm(term);
  };

  const handleSearchResultClick = (item) => {
    setSelectedRequest(item?.request);
    setSetSelectedTypeUrl(item?.entityType);
    setopen(true);
  };

  useEffect(() => {
    if (searchData?.data) {
      setSearchResults(searchData.data?.content);
    }
  }, [searchData]);

  function createDataEnterprise(N, RequestId, Raison, NIU, Motif, Type, Date, Status, Options) {
    return { N, RequestId, Raison, NIU, Motif, Type, Date, Status, Options };
  }

  function createDataEmployees(
    N,
    RequestId,
    Enterprise,
    Noms,
    Nationality,
    Motif,
    Type,
    Date,
    Status,
    Options
  ) {
    return {
      N,
      RequestId,
      Enterprise,
      Noms,
      Nationality,
      Motif,
      Type,
      Date,
      Status,
      Options,
    };
  }

  function createDataContracts(
    N,
    RequestId,
    Enterprise,
    Noms,
    Nationality,
    Salary,
    Motif,
    Type,
    Date,
    Status,
    Options
  ) {
    return {
      N,
      RequestId,
      Enterprise,
      Noms,
      Nationality,
      Salary,
      Motif,
      Type,
      Date,
      Status,
      Options,
    };
  }

  const handleClick = (item, selectedTypeUrl) => {
    if (item) {
      setSelectedRequest(item);
      setSetSelectedTypeUrl(selectedTypeUrl);
      setopen(true);
    }
  };

  const enterpriseRows = enterprises?.data?.content
    ?.filter((f) => f?.requestType !== 'CREATE')
    .map((item, index) => {
      return {
        handleClick: () => handleClick(item?.request, 'ENTERPRISE'),
        datas: createDataEnterprise(
          params?.page * params?.limit + (index + 1),
          item.request?.requestId,
          <span className="fs-c">
            {item?.request?.socialRaison || item?.request?.enterprise?.socialRaison}
          </span>,
          item?.request?.nui?.toUpperCase() || item?.request?.enterprise?.nui?.toUpperCase(),
          item?.request?.motif,
          REQUEST_TYPE[item?.request?.requestType]?.label,
          formatDate(item?.request?.createdAt),
          item?.request?.status === 'REJECTED' ? (
            <Chip
              color="error"
              variant="outlined"
              className="capitalize-none"
              label={capitalize(t('status_rejected'))}
            /> // Traduit
          ) : item?.request?.status === 'COMPLETED' ? (
            <Chip
              className="capitalize-none"
              variant="outlined"
              color="success"
              label={t('status_validated')}
            /> // Traduit
          ) : (
            <Chip
              className="capitalize-none"
              variant="outlined"
              color="warning"
              label={t('status_pending')}
            />
          ), // Traduit
          <MButton variant={'white'} onClick={(e) => {}}>
            {t('consult_button')} {/* Traduit */}
          </MButton>
        ),
      };
    });

  const employeesRows = employees?.data?.content?.map((item, index) => {
    return {
      handleClick: (e) => handleClick(item?.request, 'EMPLOYEE'),
      datas: createDataEmployees(
        index + 1,
        item.request?.requestId,
        item?.request?.employer?.enterprise?.socialRaison,
        item?.request?.employer?.fullName ||
          item?.request?.employer?.firstName + ' ' + item?.request?.employer?.lastName,
        item?.request?.employer?.nationality,
        item?.request?.motif,
        REQUEST_TYPE[item?.request?.requestType]?.label,
        formatDate(item?.request?.createdAt),
        item?.request?.status === 'REJECTED' ? (
          <Chip
            color="error"
            variant="outlined"
            className="capitalize-none"
            label={capitalize(t('status_rejected'))}
          /> // Traduit
        ) : item?.request?.status === 'COMPLETED' ? (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="success"
            label={t('status_validated')}
          /> // Traduit
        ) : (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="warning"
            label={t('status_pending')}
          />
        ), // Traduit
        <MButton variant={'white'} onClick={(e) => {}}>
          {t('consult_button')} {/* Traduit */}
        </MButton>
      ),
    };
  });

  const contractsRows = contracts?.data?.content?.map((item, index) => {
    return {
      handleClick: (e) => handleClick(item?.request, 'CONTRACT'),
      datas: createDataContracts(
        index + 1,
        item.request?.requestId,
        item?.request?.contract?.employer?.enterprise?.socialRaison,
        item?.request?.contract?.employer?.fullName ||
          item?.request?.contract?.employer?.firstName +
            ' ' +
            item?.request?.contract?.employer?.lastName,
        item?.request?.contract?.employer?.nationality,
        formatNumber(item?.request?.contract?.salary),
        item?.request?.motif,
        REQUEST_TYPE[item?.requestType]?.label,
        formatDate(item?.createdAt),
        item?.request?.status === 'REJECTED' ? (
          <Chip
            color="error"
            variant="outlined"
            className="capitalize-none"
            label={capitalize(t('status_rejected'))}
          /> // Traduit
        ) : item?.request?.status === 'COMPLETED' ? (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="success"
            label={t('status_validated')}
          /> // Traduit
        ) : (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="warning"
            label={t('status_pending')}
          />
        ), // Traduit
        <MButton variant={'white'} onClick={(e) => {}}>
          {t('consult_button')} {/* Traduit */}
        </MButton>
      ),
    };
  });

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getEnterprises();
    getEmployee();
    getContracts();
  }, [params, getEnterprises, getEmployee, getContracts]); // Ajout des fonctions de récupération aux dépendances

  return (
    <>
      {selectedRequest && open && (
        <RequestDetails
          open={open}
          selectedRequest={selectedRequest}
          requestEntityType={selectedTypeUrl}
          get={getAll}
          handleClose={() => {
            setopen(false);
            setSelectedRequest(false);
          }}
        />
      )}
      <Box sx={{}}>
        <AppBar
          position="static"
          className="flex items-center flex-1"
          sx={{ width: '100%', backgroundColor: 'white', color: 'black' }}
        >
          <Tabs
            centered
            value={value}
            onChange={handleChange}
            aria-label="Request"
            indicatorColor="primary"
            textColor="inherit"
          >
            <Tab
              icon={<BsBank2 size={25} />}
              label={
                <span>
                  {t('tab_enterprise')}
                  <span className="text-red-500 ms-1">{`(${enterprises?.data?.totalElements || '--'})`}</span>
                </span>
              }
              {...a11yProps(0)}
            />
            <Tab
              icon={<BsPeople size={25} />}
              label={
                <span>
                  {t('tab_employees')}
                  <span className="text-red-500 ms-1">{`(${employees?.data?.totalElements || '--'})`}</span>
                </span>
              }
              {...a11yProps(1)}
            />
            <Tab
              icon={<BsCardHeading size={25} />}
              label={
                <span>
                  {t('tab_contracts')}
                  <span className="text-red-500 ms-1">{`(${contracts?.data?.totalElements || '--'})`}</span>
                </span>
              }
              {...a11yProps(2)}
            />
          </Tabs>
        </AppBar>
        <div className="flex justify-center mt-4 shadow">
          <div className="flex justify-center w-full gap-4">
            <SearchRequestModal
              searchResults={searchResults}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              placeholder={t('search_request_placeholder') || "Entrez l'identifiant de la requête"}
              iconLabel={t('search_button') || 'Rechercher'}
              title={t('search_requests_title') || 'Rechercher une requête'}
              searchFunction={searchFunction}
              handleClickResult={handleSearchResultClick}
              loading={loadingSearch}
            />
          </div>
          <div className="flex justify-end gap-4">
            <MuiSelect
              wrapperClasses={'bg-white'}
              label={t('choose_status')} // Traduit
              sort={false}
              value={params.status}
              emptyLabel={t('status_all')} // Traduit
              options={[
                { label: t('status_pending'), value: 'PENDING' },
                { label: t('status_validated'), value: 'COMPLETED' },
                { label: t('status_rejected'), value: 'REJECTED' },
              ]}
              onChange={(event) => setParams({ ...params, status: event.target.value })}
            />
          </div>
        </div>

        <div className="bg-white">
          <CustomTabPanel value={value} index={0}>
            <MuiTable
              loading={loadingEnter}
              className={''}
              hidePagiation={true}
              columns={ENTERPRISE_REQUEST_HEADER(t)}
              rows={enterpriseRows}
              textEmpty={t('no_request')}
            />{' '}
            {/* Traduit */}
            <PaginateBox
              total={enterprises?.data?.totalElements}
              rowsPerPage={params?.limit}
              handleChangeRowsPerPage={(event) => {
                setParams({
                  ...params,
                  limit: parseInt(event.target.value),
                  page: 0,
                });
              }}
              page={params.page}
              count={enterprises?.data?.totalPages - 1}
              handleChange={(event, value) => {
                setParams({ ...params, page: value });
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <MuiTable
              loading={loadingEM}
              className={''}
              hidePagiation={true}
              columns={EMLOYEE_REQUEST_HEADER(t)}
              rows={employeesRows}
              textEmpty={t('no_request')}
            />{' '}
            {/* Traduit */}
            <PaginateBox
              total={employees?.data?.totalElements}
              rowsPerPage={params?.limit}
              handleChangeRowsPerPage={(event) => {
                setParams({
                  ...params,
                  limit: parseInt(event.target.value),
                  page: 0,
                });
              }}
              page={params.page}
              count={employees?.data?.totalPages - 1}
              handleChange={(event, value) => {
                setParams({ ...params, page: value });
              }}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <MuiTable
              loading={loadingCOn}
              className={''}
              hidePagiation={true}
              columns={CONTRACT_REQUEST_HEADER(t)}
              rows={contractsRows}
              textEmpty={t('no_request')}
            />{' '}
            {/* Traduit */}
            <PaginateBox
              total={contracts?.data?.totalElements}
              rowsPerPage={params?.limit}
              handleChangeRowsPerPage={(event) => {
                setParams({
                  ...params,
                  limit: parseInt(event.target.value),
                  page: 0,
                });
              }}
              page={params.page}
              count={contracts?.data?.totalPages - 1}
              handleChange={(event, value) => {
                setParams({ ...params, page: value });
              }}
            />
          </CustomTabPanel>
        </div>
      </Box>
    </>
  );
};

export default Requests;
